module.exports = __webpack_public_path__ + "static/pic02-1b2f7a33ef245eea1497a18b91d8e193.jpg";